import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';
import { ReembolsoService } from '../../core/services/http/reembolso.service';
import { SweetAlertService } from '../../core/services/sweet-alert/sweet-alert.service';
import { ReporteriaService } from '../../core/services/http/reporteria/reporteria.service';
import { VentabonosService } from 'src/app/core/services/http/ventabonos.service';
import { BonogesService } from 'src/app/core/services/http/bonoges.service';
export class MenuComponent {
    constructor(router, authService, reembolsoService, sweetAlertService, reporteriaService, ventabonosService, bonogesService) {
        this.router = router;
        this.authService = authService;
        this.reembolsoService = reembolsoService;
        this.sweetAlertService = sweetAlertService;
        this.reporteriaService = reporteriaService;
        this.ventabonosService = ventabonosService;
        this.bonogesService = bonogesService;
        this.img = 'assets/img/slider-home.png';
        this.title = '';
        this.excedentes = 0;
        this.perfilUsuario = '';
        this.cotizante = {};
        this.gesActivo = false;
    }
    ngOnInit() {
        this.consultarCotizante();
    }
    consultarCotizante() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.sweetAlertService.swalLoading();
            const data = yield this.reembolsoService.getDatosCotizante();
            if (data['status']) {
                this.perfilUsuario = data['data']['codigoPerfil'].toString();
                this.cotizante = data['data'];
            }
            yield this.getExcedentes();
            yield this.getGesActivo();
            this.sweetAlertService.swalClose();
        });
    }
    getExcedentes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.ventabonosService.getExcedentes(this.cotizante['marca']);
            if (response['status']) {
                this.excedentes = response['data']['excedentes'];
            }
        });
    }
    getGesActivo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rutCotizante = this.getCotizante();
            const data = {
                rutCotizante,
                incluyeCotizante: true
            };
            const response = yield this.bonogesService.getBeneficiarios(data);
            if (response['status']) {
                const beneficiario = response['data'].filter(ben => {
                    return (ben.rutBen === rutCotizante) || (ben.rutBen === this.rutBeneficiario) || (ben.relacion.includes('HIJO'));
                });
                if (beneficiario.length) {
                    this.gesActivo = beneficiario[0]['tieneGesActivo'];
                }
            }
        });
    }
    getCotizante() {
        if (this.cotizante['tipoPerfil'] === 'BENEFICIARIO') {
            this.rutBeneficiario = this.cotizante['rutBeneficiario'];
            return this.cotizante['rutCotizante'];
        }
        else {
            return parseInt(localStorage.getItem('cbRutCliente'), 10);
        }
    }
    menu(e, action) {
        e.preventDefault();
        this.itemMenu = action;
        this.router.navigate([action]);
    }
    logout() {
        this.reporteUsabilidad('Cerrar sesión', 'Cierre de sesión de usuario', true);
        this.authService.logout();
    }
    reporteUsabilidad(recurso, respuesta, status) {
        const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');
        this.reporteriaService.saveLog('Menú', recurso, respuesta, 'Front-End', status, rut);
    }
}
